import { Card, FormLayout, Layout, TextField } from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import { CsValidation as V, CsValidationForm } from "../../shared/csValidationForm";
import TooltipHelper from "../../helpers/TooltipHelper";
import Switch from "react-switch/index";
import React from "react";

const CompanyLegalInfo = (props) => {
  const {
    hasVatNumber, vatNumber, hasDunsNumber, dunsNumber,
    physicalStore, subcontractedCarriers,
    handleChange,
    validatorClass,
  } = props;

  return (
    <Layout.AnnotatedSection
      title={CsI18n.t("company.annotate.title.legal_info")}
      description={CsI18n.t("company.annotate.desc.legal_info")}>
      <Card>
        <Card.Section>
          <CsValidationForm name={validatorClass} realtime={true}>
            <FormLayout>
              <FormLayout.Group>
                <div>
                  <p><CsI18n>VAT Number</CsI18n>{TooltipHelper.light(CsI18n.t("company.explain.vat_number"))}</p>
                  <Switch
                    className="react-switch"
                    onChange={handleChange('hasVatNumber')}
                    checked={hasVatNumber}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    aria-label={CsI18n.t("VAT Number")}
                  />
                  <div className="other-text">
                    {hasVatNumber &&
                    <V>
                      <TextField label="" onChange={handleChange('vatNumber')} value={vatNumber} />
                      <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                      <V.Item rule="eu_vat_number" title={CsI18n.t("Not a valid VAT number.")} />
                    </V>}
                  </div>
                </div>
              </FormLayout.Group>

              <FormLayout.Group>
                <div>
                  <p><CsI18n>DUNS Number</CsI18n>{TooltipHelper.light(CsI18n.t("company.explain.duns_number"))}</p>
                  <Switch
                    className="react-switch"
                    onChange={handleChange('hasDunsNumber')}
                    checked={hasDunsNumber}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    aria-label={CsI18n.t("DUNS Number")}
                  />
                  <div className="other-text">
                    {hasDunsNumber &&
                    <V>
                      <TextField label="" onChange={handleChange('dunsNumber')} value={dunsNumber} />
                      <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                      <V.Item rule="number" title={CsI18n.t("Not a valid DUNS number.")} />
                    </V>}
                  </div>
                </div>
              </FormLayout.Group>

              <FormLayout.Group>
                <div>
                  <p><CsI18n>Physical store</CsI18n>{TooltipHelper.light(CsI18n.t("company.explain.physical_store"))}</p>
                  <Switch
                    className="react-switch"
                    onChange={handleChange('physicalStore')}
                    checked={physicalStore}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    aria-label={CsI18n.t("Physical store")}
                  />
                </div>
                <div>
                  <p><CsI18n>Subcontracted carriers</CsI18n>{TooltipHelper.light(CsI18n.t("company.explain.subcontracted_carriers"))}</p>
                  <Switch
                    className="react-switch"
                    onChange={handleChange('subcontractedCarriers')}
                    checked={subcontractedCarriers}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    aria-label={CsI18n.t("Subcontracted carriers")}
                  />
                </div>
              </FormLayout.Group>

            </FormLayout>
          </CsValidationForm>
        </Card.Section>
      </Card>
    </Layout.AnnotatedSection>
  )
};

export default CompanyLegalInfo;